import styled from 'styled-components';

export const PromoStatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const HeaderContainer = styled.div`
    align-items: start;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const StatsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    thead tr {
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    th {
        color: #FFFFFF;
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        font-weight: 600;
        padding: 10px 14px;
        text-align: left;
        white-space: nowrap;
    }

    tbody tr {
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        transition: background-color 0.15s;

        &:last-child {
            border-bottom: none;
        }
    }

    td {
        color: #FFFFFF;
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        padding: 8px 0px;
        vertical-align: middle;
        
    }
`;

export const CodeBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: #e8f4fd;
    color: #0c6fa8;
    font-family: monospace;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.5px;
`;

export const CountBadge = styled.span`
    display: inline-block;
    min-width: 28px;
    padding: 2px 8px;
    border-radius: 12px;
    background-color: #e8f5e9;
    color: #2e7d32;
    font-weight: 700;
    font-size: 13px;
    text-align: center;
`;

export const RedemptionList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
    padding: 10px 12px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const RedemptionRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1.4fr;
    gap: 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    padding: 4px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

    &:last-child {
        border-bottom: none;
    }

    span:first-child {
        font-weight: 600;
        color: #FFFFFF;
    }
`;

export const RedemptionHeader = styled(RedemptionRow)`
    font-weight: 700;
    color: rgba(255, 255, 255, 0.45);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    padding-bottom: 6px;
    margin-bottom: 2px;
`;

export const EmptyState = styled.div`
    padding: 32px;
    text-align: center;
    color: #aaa;
    font-size: 14px;
`;

export const LoadingState = styled.div`
    padding: 24px;
    text-align: center;
    color: #888;
    font-size: 14px;
`;

